import React, { useRef } from "react"
import OnlyOfficeEditor from "./OnlyEditor";

const OnlyOfficeFileEditor: React.FC = () => {

    return (
        <div>
            <h1>Document Editor</h1>
            <OnlyOfficeEditor />
        </div>
    );
};

export default OnlyOfficeFileEditor;



